export const StopCircleFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill="#3A7BD5" />
      <rect x="11" y="11" width="8" height="8" rx="1.2" fill="white" />
    </svg>
  );
};
